import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule } from '@angular/router';

export const routingConfiguration: ExtraOptions = {
    paramsInheritanceStrategy: 'always',
    relativeLinkResolution: 'legacy',
};

@NgModule({
    imports: [RouterModule.forRoot([], routingConfiguration)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
